module.exports = __webpack_public_path__ + "img/transparencia_one.0f84bafc.png";